import { render, staticRenderFns } from "./kcxzContent.vue?vue&type=template&id=c67f9460&scoped=true"
import script from "./kcxzContent.vue?vue&type=script&lang=ts"
export * from "./kcxzContent.vue?vue&type=script&lang=ts"
import style0 from "./kcxzContent.vue?vue&type=style&index=0&id=c67f9460&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67f9460",
  null
  
)

export default component.exports